// Libraries
import { format } from 'date-fns-tz';
// Types
import { TooltipDecorator, TooltipDecoratorTypesEnum } from '@molecules/index';
import { LineTooltipResistanceProps } from './LineTooltipResistance.types';
// Utils
import text from '@translations/en.json';
import { transformText, CapitalizeType, formatValue } from '@helpers/index';

/**
 * LineTooltipWrapper is a component that wraps a Victory bar tooltip with custom content.
 *
 * @component
 * @param {LineTooltipResistanceProps} props - Props for the BarTooltipWrapper component.
 * @param {VesselRatingSummary} props.datum - The data point object for which the tooltip is being rendered.
 * @param {number} [props.x=0] - The x-coordinate of the tooltip position.
 * @param {number} [props.y=0] - The y-coordinate of the tooltip position.
 * @returns {ReactElement} A component that renders a custom tooltip for a Victory bar.
 */
export const LineTooltipResistance = ({ x = 0, y = 0, datum }: LineTooltipResistanceProps) => {
  // Destructure properties from the datum object, the assertion comes from the
  // the non type model of victory to use {datum}.
  const { x: xValue = 0, y: yValue = 0 } = datum ?? {};

  const labels = `${transformText(text.resistance, CapitalizeType.sentencecase)}: ${formatValue(yValue, 2)}`;
  const xAxisCorrection = x - 45;

  return (
    <TooltipDecorator
      type={TooltipDecoratorTypesEnum.LabelTooltip}
      positionObject={{
        x: xAxisCorrection,
        y,
      }}
      title={format(new Date(xValue), 'MMM d, yyyy')}
      params={{
        labels,
      }}
    />
  );
};
